function CursorRenderer(ctx) {
  return {
    renderEllipseToolCursor() {
      ctx.canvas.style.cursor = 'crosshair'
    },
    renderPenEraserToolCursor() {
      ctx.canvas.style.cursor = 'crosshair'
    },
    renderPenToolCursor() {
      ctx.canvas.style.cursor = 'crosshair'
    },
    renderPolygonToolCursor() {
      ctx.canvas.style.cursor = 'crosshair'
    },
    renderPolylineToolCursor() {
      ctx.canvas.style.cursor = 'crosshair'
    },
    renderRectangleToolCursor() {
      ctx.canvas.style.cursor = 'crosshair'
    },
    renderTextCreatorCursor() {
      ctx.canvas.style.cursor = 'text'
    },
    renderTextEditorCursor() {
      ctx.canvas.style.cursor = 'default'
    },
    renderOpenHandCursor() {
      ctx.canvas.style.cursor = 'grab'
    },
    renderClosedHandCursor() {
      ctx.canvas.style.cursor = 'grabbing'
    },
    renderMoveCursor() {
      ctx.canvas.style.cursor = 'move'
    },
    renderArrowCursor() {
      ctx.canvas.style.cursor = 'default'
    },
  }
}

module.exports = CursorRenderer
